import "./style.css";

function Loader() {
  return (
    // <div className="loading-container">
    //     <div className="spinner"></div>
    //     <div className="loading-text">Loading!!!</div>
    // </div>
    <div>.</div>
  );
}

function WaveSkeletonLoader({ width = "200px", height = "20px" }) {
  return <div className="wave-skeleton" style={{ width, height }}></div>;
}

function DotWaveLoader({ width = "200px", height = "20px" }) {
  return (
    <div className="dot-wave-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

function BubbleLoader() {
  return <div className="Bubbleloader" />;
}

function BookLoader() {
  return (
    <div className="loader">
      <div>
        <ul>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
          <li>
            <svg fill="currentColor" viewBox="0 0 90 120">
              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z" />
            </svg>
          </li>
        </ul>
      </div>
      <span>Loading</span>
    </div>
  );
}

function BirdLoader() {
  return (
    <div className="cloud-loader">
      <svg id="cloud" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <defs>
          <filter id="roundness">
            <feGaussianBlur in="SourceGraphic" stdDeviation="1.5" />
            <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 20 -10" />
          </filter>
          <mask id="shapes">
            <g fill="white">
              <polygon points="50 37.5 80 75 20 75 50 37.5" />
              <circle cx={20} cy={60} r={15} />
              <circle cx={80} cy={60} r={15} />
              <g>
                <circle cx={20} cy={60} r={15} />
                <circle cx={20} cy={60} r={15} />
                <circle cx={20} cy={60} r={15} />
              </g>
            </g>
          </mask>
          <mask id="clipping" clipPathUnits="userSpaceOnUse">
            <g id="lines" filter="url(#roundness)">
              <g mask="url(#shapes)" stroke="white">
                <line x1={-50} y1={-40} x2={150} y2={-40} />
                <line x1={-50} y1={-31} x2={150} y2={-31} />
                <line x1={-50} y1={-22} x2={150} y2={-22} />
                <line x1={-50} y1={-13} x2={150} y2={-13} />
                <line x1={-50} y1={-4} x2={150} y2={-4} />
                <line x1={-50} y1={5} x2={150} y2={5} />
                <line x1={-50} y1={14} x2={150} y2={14} />
                <line x1={-50} y1={23} x2={150} y2={23} />
                <line x1={-50} y1={32} x2={150} y2={32} />
                <line x1={-50} y1={41} x2={150} y2={41} />
                <line x1={-50} y1={50} x2={150} y2={50} />
                <line x1={-50} y1={59} x2={150} y2={59} />
                <line x1={-50} y1={68} x2={150} y2={68} />
                <line x1={-50} y1={77} x2={150} y2={77} />
                <line x1={-50} y1={86} x2={150} y2={86} />
                <line x1={-50} y1={95} x2={150} y2={95} />
                <line x1={-50} y1={104} x2={150} y2={104} />
                <line x1={-50} y1={113} x2={150} y2={113} />
                <line x1={-50} y1={122} x2={150} y2={122} />
                <line x1={-50} y1={131} x2={150} y2={131} />
                <line x1={-50} y1={140} x2={150} y2={140} />
              </g>
            </g>
          </mask>
        </defs>
        <rect
          x={0}
          y={0}
          width={100}
          height={100}
          rx={0}
          ry={0}
          mask="url(#clipping)"
        />
        <g>
          <path d="M33.52,68.12 C35.02,62.8 39.03,58.52 44.24,56.69 C49.26,54.93 54.68,55.61 59.04,58.4 C59.04,58.4 56.24,60.53 56.24,60.53 C55.45,61.13 55.68,62.37 56.63,62.64 C56.63,62.64 67.21,65.66 67.21,65.66 C67.98,65.88 68.75,65.3 68.74,64.5 C68.74,64.5 68.68,53.5 68.68,53.5 C68.67,52.51 67.54,51.95 66.75,52.55 C66.75,52.55 64.04,54.61 64.04,54.61 C57.88,49.79 49.73,48.4 42.25,51.03 C35.2,53.51 29.78,59.29 27.74,66.49 C27.29,68.08 28.22,69.74 29.81,70.19 C30.09,70.27 30.36,70.31 30.63,70.31 C31.94,70.31 33.14,69.44 33.52,68.12Z" />
          <path d="M69.95,74.85 C68.35,74.4 66.7,75.32 66.25,76.92 C64.74,82.24 60.73,86.51 55.52,88.35 C50.51,90.11 45.09,89.43 40.73,86.63 C40.73,86.63 43.53,84.51 43.53,84.51 C44.31,83.91 44.08,82.67 43.13,82.4 C43.13,82.4 32.55,79.38 32.55,79.38 C31.78,79.16 31.02,79.74 31.02,80.54 C31.02,80.54 31.09,91.54 31.09,91.54 C31.09,92.53 32.22,93.09 33.01,92.49 C33.01,92.49 35.72,90.43 35.72,90.43 C39.81,93.63 44.77,95.32 49.84,95.32 C52.41,95.32 55,94.89 57.51,94.01 C64.56,91.53 69.99,85.75 72.02,78.55 C72.47,76.95 71.54,75.3 69.95,74.85Z" />
        </g>
      </svg>
    </div>
  );
}

const CampLoader = () => {
  return (
    <div className="scene">
      <div className="forest">
        <div className="tree tree1">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
        </div>
        <div className="tree tree2">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
        <div className="tree tree3">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
        <div className="tree tree4">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
        <div className="tree tree5">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
        <div className="tree tree6">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
        <div className="tree tree7">
          <div className="branch branch-top" />
          <div className="branch branch-middle" />
          <div className="branch branch-bottom" />
        </div>
      </div>
      <div className="tent">
        <div className="roof" />
        <div className="roof-border-left">
          <div className="roof-border roof-border1" />
          <div className="roof-border roof-border2" />
          <div className="roof-border roof-border3" />
        </div>
        <div className="entrance">
          <div className="door left-door">
            <div className="left-door-inner" />
          </div>
          <div className="door right-door">
            <div className="right-door-inner" />
          </div>
        </div>
      </div>
      <div className="floor">
        <div className="ground ground1" />
        <div className="ground ground2" />
      </div>
      <div className="fireplace">
        <div className="support" />
        <div className="support" />
        <div className="bar" />
        <div className="hanger" />
        <div className="smoke" />
        <div className="pan" />
        <div className="fire">
          <div className="line line1">
            <div className="particle particle1" />
            <div className="particle particle2" />
            <div className="particle particle3" />
            <div className="particle particle4" />
          </div>
          <div className="line line2">
            <div className="particle particle1" />
            <div className="particle particle2" />
            <div className="particle particle3" />
            <div className="particle particle4" />
          </div>
          <div className="line line3">
            <div className="particle particle1" />
            <div className="particle particle2" />
            <div className="particle particle3" />
            <div className="particle particle4" />
          </div>
        </div>
      </div>
      <div className="time-wrapper">
        <div className="time">
          <div className="day" />
          <div className="night">
            <div className="moon" />
            <div className="star star1 star-big" />
            <div className="star star2 star-big" />
            <div className="star star3 star-big" />
            <div className="star star4" />
            <div className="star star5" />
            <div className="star star6" />
            <div className="star star7" />
          </div>
        </div>
      </div>
    </div>
  );
};
const PillLoader = () => {
  return (
    <div className="liquid-loader">
      <div className="loading-text">
        Loading<span className="dot">.</span>
        <span className="dot">.</span>
        <span className="dot">.</span>
      </div>
      <div className="loader-track">
        <div className="liquid-fill" />
      </div>
    </div>
  );
};

function ReportLoader ()  {
  return (
      <div className="report-loader">
        <div className="justify-content-center jimu-primary-loading" />
      </div>
  );
};

function LevelsSkillReportLoader() {
  return (
      <div className="levels-skill-report-loader">
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
  );
}

const ViewSkillLoader = () => {
  return (
      <div className="view-skill-loader">
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-text"><span>Loading</span></div>
        <div className="view-skill-line" />
      </div>
  );
}

function BlobLoader({ text = "Loading" }) {
  return (
    <div className="blob-loader">
      <div className="blob-loader-bg">
        <span className="blob blob-1" />
        <span className="blob blob-2" />
        <span className="blob blob-3" />
        <span className="blob blob-4" />
      </div>

      <div className="blob-loader-content">
        <div className="blob-loader-spinner">
          <span className="blob-dot" />
          <span className="blob-dot" />
          <span className="blob-dot" />
        </div>
        <p className="blob-loader-text">
          {text}
          <span className="blob-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </div>
  );
}

export {
  Loader,
  WaveSkeletonLoader,
  DotWaveLoader,
  BubbleLoader,
  BookLoader,
  BirdLoader,
  CampLoader,
  PillLoader,
  ReportLoader,
  LevelsSkillReportLoader,
  BlobLoader,
  ViewSkillLoader,
};